import React, { useState, Fragment, useEffect } from 'react';
import Carousel from "react-multi-carousel";
import { translate } from '../Services/translation';

const EyeHealthServicesBlock = (props) => {    
    const [isMounted, setisMounted] = useState(false);
    const [activeIndex, setactiveIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
    const checkWidth = () => {
        setIsMobile(window.innerWidth < 484); 
    };

    checkWidth();
    window.addEventListener("resize", checkWidth);

    return () => window.removeEventListener("resize", checkWidth);
    }, []);

    let responsiveness = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: { max: 1024, min: 484 },
            items: 2,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 484, min: 0 },
            items: 1,
            slidesToSlide: 1,
        }
    }
    let settings = {
        infinite: true,
        swipeable: true,
        draggable: false,
        showDots: false,
        arrows: false,
        responsive: responsiveness,
        keyBoardControl: true,
        transitionDuration: 500,
        itemClass: "carousel-item",
        //centerMode: !isMobile,        
        minimumTouchDrag: 10,
        renderButtonGroupOutside: true,
        transitionDuration: 300,
        partialVisible: true,
    }

    useEffect(() => {
        if (props.services) {
            setisMounted(true);
        }
    }, []);

    const CustomButtonGroupAsArrows = ({ next, previous, carouselState }) => {        
        return (
            <Fragment>                
                {carouselState.totalItems > carouselState.slidesToShow &&
                    <div className="multi-carousel__buttons">
                        <button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left" onClick={previous} aria-label="Multicarousel arrow left"></button>                        
                        <button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right" onClick={next} aria-label="Multicarousel arrow right"></button>
                    </div>
                }
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Carousel {...settings} customButtonGroup={<CustomButtonGroupAsArrows />}>
                {isMounted && props.services.map((item, index) => {
                    return (
                        <Fragment key={index}>
                            {isMounted &&
                                <div className='servicesblock__serviceitem' title={item.title} key={item.title + index}>
                                    <div className='servicesblock__serviceitem-title'>{item.title}</div>
                                    <div className='servicesblock__serviceitem-text' dangerouslySetInnerHTML={{ __html: item.text }}></div>
                                </div>
                            } 
                            <div className='servicesblock__slidenumber'>{index + 1} {translate("coptikk.eyehealthclinic.carousel.oftext")} {props.services.length}</div>                           
                        </Fragment>
                    )
                })}                
            </Carousel>
        </Fragment>
    )
}

export default EyeHealthServicesBlock;